module.exports = __webpack_public_path__ + "static/aaa-4f776b684ee15649c10659e3c82338b3.svg";